import { render, staticRenderFns } from "./BidsItem.vue?vue&type=template&id=44edb0ac&"
import script from "./BidsItem.vue?vue&type=script&lang=js&"
export * from "./BidsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports